import React, { createContext, useContext, useState, ReactNode } from "react";

export interface SheAiVideoContextType {
  video: string;
  setVideo: (v: string) => void;
  videoId: string;
  setVideoId: (v: string) => void;
  arrVideo: any[];
  setArrVideo: (v: any[]) => void;
  cameraMain: boolean;
  setCameraMain: (v: boolean) => void;
}

const SheAiVideoContext = createContext<SheAiVideoContextType | undefined>(undefined);

export const SheAiVideoProvider = ({ children }: { children: ReactNode }) => {
  const [video, setVideo] = useState("");
  const [videoId, setVideoId] = useState("");
  const [arrVideo, setArrVideo] = useState<any[]>([]);
  const [cameraMain, setCameraMain] = useState(false);

  return (
    <SheAiVideoContext.Provider
      value={{ video, setVideo, videoId, setVideoId, arrVideo, setArrVideo, cameraMain, setCameraMain }}
    >
      {children}
    </SheAiVideoContext.Provider>
  );
};

export const useSheAiVideo = () => {
  const context = useContext(SheAiVideoContext);
  if (!context) {
    throw new Error("useSheAiVideo must be used within a SheAiVideoProvider");
  }
  return context;
};
